import { useEffect, useState } from 'react'
import { useStateValue } from '../../../providers'
import { useParams } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'
import { useGetQuery, usePostQuery } from 'hooks'
import {
  Card,
  Icon,
  Tag,
  Title,
  Wrapper
} from 'components'

const addSlug = (arry) => {
  return arry?.map((a) => ({ ...a, slug: `${a.subject}:${a.action}` }))
}

const permissionCollection = (permissions = [], existing = []) => {
  const perms = permissions.filter(
    (p) =>
      [...existing].find(
        (e) => e.action + e.subject === p.action + p.subject
      ) === undefined
  )
  return addSlug(perms)
}

export const AdminRole = () => {
  const [{ session }] = useStateValue()
  const { slug } = useParams()
  const { colors } = useTheme()

  const { data: roleData, refetch: refetchRole } = useGetQuery({ url: `/admin/roles/${slug}` })
  const { data: permData } = useGetQuery({ url: '/admin/permissions' })
  const { post: assignPerm } = usePostQuery({ url: '/admin/permissions/assign' })
  const { post: removePerm } = usePostQuery({ url: '/admin/permissions/assign', method: 'DELETE' })

  const role = roleData?.role
  const allPermsList = permData?.permissions

  const currentPerms = addSlug(role?.permissions) || []
  const availablePerms = permissionCollection(allPermsList, currentPerms)

  const addPerm = async (permission) => {
    await assignPerm({ actor_id: session.user.id, permission_id: permission.id, role_id: role?.id })
    refetchRole(true)
  }

  const delPerm = async (permissionAssignment) => {
    await removePerm({ actor_id: session.user.id, permission_id: permissionAssignment?.permission_id, role_id: role?.id })
    refetchRole(true)
  }

  if (!role) return null

  return (
    <Card>
      <Title level="2">{role?.name} role</Title>
      <div>{role?.description}</div>
      <Wrapper margin="0.5rem 0">
        <Title level="4">current permissions</Title>
        <Wrapper>
          {currentPerms?.map((p, i) => (
            <Tag className="active" key={`add${p.id}${i}`}>
              {p.subject}:{p.action}&nbsp;
              <Icon
                className="accent"
                height="12"
                icon="minus"
                onClick={() => delPerm(p.permission_assignments)}
                fill={colors('text')}
                width="12"
              />
            </Tag>
          ))}
        </Wrapper>
      </Wrapper>
      <Title level="4">available permissions</Title>
      <Wrapper margin="1rem 0 0">
        {availablePerms?.map((p) => (
          <Tag key={`add${p.id}`}>
            {p.subject}:{p.action}&nbsp;
            <Icon
              className="accent"
              height="12"
              icon="plus"
              onClick={() => addPerm(p)}
              fill={colors('highlight')}
              width="12"
            />
          </Tag>
        ))}
      </Wrapper>
    </Card>
  )
}
